<template>
  <span
    class="overflow-options-cont"
    :id="'overflow_options_cont_id_' + menu_id"
    :style="{
      'z-index': overflow_menu_details.open_menu_id == menu_id ? '1' : ''
    }"
  >
    <a
      class="overflow-btn"
      :id="'overflow_icon_' + menu_id"
      @click="toggle_menu(menu_id)"
    ></a>
    <div
      class="popper-cont"
      :id="'overflow_menu_' + menu_id"
      :class="{
        hidden: overflow_menu_details.open_menu_id != menu_id
      }"
    >
      <div data-popper-arrow class="popper_arrow"></div>
      <span class="overflow-options">
        <slot />
      </span>
    </div>
  </span>
</template>

<script>
import { createPopper } from "@popperjs/core";

export default {
  name: "OverflowMenu",
  model: {
    prop: "overflow_menu_details",
    event: "overflow-menu-details-changed"
  },
  props: {
    menu_id: {
      type: [Number, String]
    },
    overflow_menu_details: {
      type: Object
    },
    popper_position: {
      type: String,
      default: "bottom-end"
    }
  },
  data() {
    return {};
  },
  methods: {
    may_destroy_popper() {
      if (this.overflow_menu_details.popper_instance) {
        this.overflow_menu_details.popper_instance.destroy();
        this.overflow_menu_details.popper_instance = null;
      }
    },
    toggle_menu(menu_id) {
      this.overflow_menu_details.open_menu_id =
        this.overflow_menu_details.open_menu_id == menu_id ? null : menu_id;

      this.$nextTick(() => {
        if (this.overflow_menu_details.open_menu_id) {
          let element = document.querySelector("#overflow_icon_" + menu_id);
          let tooltip = document.querySelector("#overflow_menu_" + menu_id);
          this.overflow_menu_details.popper_instance = createPopper(
            element,
            tooltip,
            {
              placement: this.popper_position,
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 5]
                  }
                }
              ]
            }
          );

          this.on_click_outside("#overflow_options_cont_id_" + menu_id, () => {
            if (this.overflow_menu_details.open_menu_id == menu_id) {
              this.overflow_menu_details.open_menu_id = null;
            }
          });
        }
      });
    }
  },
  watch: {
    "overflow_menu_details.open_menu_id": function(new_value) {
      if (new_value == null) {
        this.may_destroy_popper();
      }
    }
  }
};
</script>

<style scoped>
.overflow-options-cont {
  position: absolute;
  width: 20px;
  height: 20px;
  right: 8px;
  margin-top: 2px;
}
.overflow-options-cont .popper-cont .popper_arrow::before {
  background: #b1b6d1 !important;
}
.overflow-options-cont .overflow-btn:hover {
  border-color: rgba(177, 182, 209, 0.5);
  background-color: #fff;
}
.overflow-options-cont .overflow-btn::before {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14.95 13.55'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;stroke:%23131336;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;%7D%3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Regular'%3E%3Ccircle class='cls-1' cx='7.48' cy='6.78' r='1.5'/%3E%3Cpath class='cls-1' d='M5.69,1.11l1.11,1a1,1,0,0,0,1.35,0l1.11-1a1.33,1.33,0,0,1,2.21,1.28l-.34,1.48a1,1,0,0,0,.68,1.18l1.45.45a1.34,1.34,0,0,1,0,2.56l-1.45.44a1,1,0,0,0-.68,1.17l.34,1.48a1.33,1.33,0,0,1-2.21,1.27l-1.1-1a1,1,0,0,0-1.36,0l-1.11,1a1.34,1.34,0,0,1-2.21-1.29l.34-1.48a1,1,0,0,0-.68-1.18L1.7,8A1.33,1.33,0,0,1,.81,6.36a1.37,1.37,0,0,1,.88-.89L3.14,5a1,1,0,0,0,.68-1.18L3.48,2.38a1.31,1.31,0,0,1,1-1.59A1.34,1.34,0,0,1,5.69,1.11Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  position: absolute;
  width: 14px;
  height: 13px;
  opacity: 0.5;
  margin: 3px 2px;
}
.overflow-options-cont .overflow-options {
  background-color: #fff;
  border: 1px solid #b1b6d1;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 0;
  z-index: 1;
  border-radius: 5px;
  display: block;
  overflow: hidden;
}
.overflow-options-cont .overflow-options .menu-item {
  padding: 8px 12px;
  white-space: nowrap;
  display: block !important;
  text-align: center;
}
.overflow-options-cont .overflow-options .menu-item:hover {
  text-decoration: none !important;
}
.overflow-options-cont .overflow-options .menu-item.hover-hl:hover {
  background-color: #eff3fb;
}
.overflow-options-cont .overflow-options .menu-item.del-hl:hover {
  background-color: #ffecee;
}
.overflow-options-cont .overflow-options .menu-item:not(:last-child) {
  border-bottom: 1px solid #b1b6d1;
}

.overflow-options-cont a.overflow-btn {
  width: 20px;
  height: 20px;
  border: 1px solid transparent;
  border-radius: 5px;
  margin: -5px 0 0 -1px;
  position: relative;
}
.overflow-options-cont a.overflow-btn:hover {
  border-color: rgba(177, 182, 209, 0.5);
}
.overflow-options-cont .overflow-btn::before {
  padding: 0px;
  top: 4px;
  margin: 0 !important;
  left: 3px;
}
</style>
